import React from "react";
import "../styles/components/_loader.scss";

export default function Loader() {
  return (
    <div className="loader-overlay">
      <img src={process.env.PUBLIC_URL + "/logo.png"} alt="Logo Clara Décor" className="loader-logo" />
    </div>
  );
}
